import * as types from '../../../lib/actionTypes.es6';

export var getOrgCustomerStatusConfigsRequest = function(organizationGuid) {
  return { type: types.GET_ORG_CUSTOMER_STATUS_CONFIGS_REQUEST, payload: organizationGuid };
};
export var getOrgCustomerStatusConfigsSuccess = function(payload) {
  return { type: types.GET_ORG_CUSTOMER_STATUS_CONFIGS_SUCCESS, payload: payload };
};
export var getOrgCustomerStatusConfigsFailure = function(error) {
  return { type: types.GET_ORG_CUSTOMER_STATUS_CONFIGS_FAILURE, payload: error };
};
export var createOrgCustomerStatusConfigRequest = function(payload) {
  return { type: types.CREATE_ORG_CUSTOMER_STATUS_CONFIG_REQUEST, payload: payload };
};
export var createOrgCustomerStatusConfigSuccess = function(payload) {
  return { type: types.CREATE_ORG_CUSTOMER_STATUS_CONFIG_SUCCESS, payload: payload };
};
export var createOrgCustomerStatusConfigFailure = function(error) {
  return { type: types.CREATE_ORG_CUSTOMER_STATUS_CONFIG_FAILURE, payload: error };
};
export var resetCreateOrgCustomerStatusConfigSuccess = function() {
  return { type: types.RESET_CREATE_ORG_CUSTOMER_STATUS_CONFIG_SUCCESS };
};
export var resetCreateOrgCustomerStatusConfigError = function() {
  return { type: types.RESET_CREATE_ORG_CUSTOMER_STATUS_CONFIG_ERROR };
};
export var updateOrgCustomerStatusConfigRequest = function(payload) {
  return { type: types.UPDATE_ORG_CUSTOMER_STATUS_CONFIG_REQUEST, payload: payload };
};
export var updateOrgCustomerStatusConfigSuccess = function(payload) {
  return { type: types.UPDATE_ORG_CUSTOMER_STATUS_CONFIG_SUCCESS, payload: payload };
};
export var updateOrgCustomerStatusConfigFailure = function(error) {
  return { type: types.UPDATE_ORG_CUSTOMER_STATUS_CONFIG_FAILURE, payload: error };
};
export var resetUpdateOrgCustomerStatusConfigSuccess = function() {
  return { type: types.RESET_UPDATE_ORG_CUSTOMER_STATUS_CONFIG_SUCCESS };
};
export var resetUpdateOrgCustomerStatusConfigError = function() {
  return { type: types.RESET_UPDATE_ORG_CUSTOMER_STATUS_CONFIG_ERROR };
};
export var deleteOrgCustomerStatusConfigRequest = function(payload) {
  return { type: types.DELETE_ORG_CUSTOMER_STATUS_CONFIG_REQUEST, payload: payload };
};
export var deleteOrgCustomerStatusConfigSuccess = function(payload) {
  return { type: types.DELETE_ORG_CUSTOMER_STATUS_CONFIG_SUCCESS, payload: payload };
};
export var deleteOrgCustomerStatusConfigFailure = function(error) {
  return { type: types.DELETE_ORG_CUSTOMER_STATUS_CONFIG_FAILURE, payload: error };
};
export var resetDeleteOrgCustomerStatusConfigSuccess = function() {
  return { type: types.RESET_DELETE_ORG_CUSTOMER_STATUS_CONFIG_SUCCESS };
};
export var resetDeleteOrgCustomerStatusConfigError = function() {
  return { type: types.RESET_DELETE_ORG_CUSTOMER_STATUS_CONFIG_ERROR };
};
